module.exports = __webpack_public_path__ + "static/media/goedele.4fbd42de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ambassadors/goedele.jpg
// module id = 561
// module chunks = 0